import { Parallax } from "swiper/js/swiper.esm";
import leaf1 from "../../../../svg/leaf-1.svg";
import leaf2 from "../../../../svg/leaf-2.svg";
import leaf3 from "../../../../svg/leaf-3.svg";
import leaf4 from "../../../../svg/leaf-4.svg";
import leaf5 from "../../../../svg/leaf-5.svg";

const Paragraphs = [
    '.ParagraphImageText',
    '.ParagraphCarrousel', 
    '.ParagraphWysiwyg', 
    '.ParagraphMedia',
    '.ParagraphProducts',
    '.ParagraphPromote',
    '.NodeHome-secondary-focus'
];

//ON TIRE AU SORT LE NOMBRE DE FEUILLES QUI DOIVENT APPARAITRE SUR UN PARAGRAPH (entre 0 et 2)
//ON TIRE AU SORT LE TYPE DE FEUILLES A AFFICHER EN FAISANT EN SORTE DE NE PAS SELECTIONNER DEUX FOIS LA MÊME
//ON GENERE UN ELEMENT SPAN QUI CONFIENT LE SVG DE LA FEUILLE, AVEC UNE POSITION ALEATOIRE SUR LE PARAGRAPH AINSI QU'UNE TRANSFORMATION
//ALEATOIRE (ROTATION..)

class LeafGenerator {
    constructor(element) {
        this.element = element;
        this.SVGLeaves = [leaf1, leaf2, leaf3, leaf4, leaf5];
        this.minMaxLeaves = [0, 2];
        this.defaultLeafStyle = {
            'display': 'block',
            'position': 'absolute',
            'z-index': 1,
            'top': `${this.getRandomInt(100)}%`,
            'left': `${this.getRandomInt(100)}%`,
            'height': 'auto',
        }
        this.generate();
    }

    generate() {
        let svgLeavesShallow = this.SVGLeaves.slice();
        let numberOfLeavesToGenerate = Array.from(Array(this.getRandomInt(this.minMaxLeaves[this.minMaxLeaves.length - 1] + 1)));
  
        numberOfLeavesToGenerate.map(() => {
            let leafIndexSelected = this.getRandomInt(svgLeavesShallow.length - 1);
            let leafSelected = svgLeavesShallow[leafIndexSelected];
            svgLeavesShallow.splice(leafIndexSelected, 1);
            let spanElement = document.createElement("span");
            spanElement.dataset.parallax = this.getRandomFloat(-0.6, -0.15);
            this.defaultLeafStyle.top = `${this.getRandomIntInclusive(-5, 105)}%`;
            let horizontalPosition = this.getRandomIntInclusive(-10, 10);
            let randomWidth = this.getRandomIntInclusive(120, 150);
            this.defaultLeafStyle.width = `${randomWidth}px`;
            //this.defaultLeafStyle.transform = `rotate(${this.getRandomIntInclusive(0, 180)}deg)`;

            if(Math.sign(horizontalPosition) === -1) {
                this.defaultLeafStyle.left = `calc(${horizontalPosition}% - ${randomWidth}px)`;
                this.defaultLeafStyle.right = 'unset';
            } else {
                this.defaultLeafStyle.right = `calc(-${horizontalPosition}% - ${randomWidth}px)`;
                this.defaultLeafStyle.left = 'unset';
            }
            Object.assign(spanElement.style, this.defaultLeafStyle);
            spanElement.innerHTML = leafSelected;
            this.element.appendChild(spanElement);
            spanElement.querySelectorAll('svg')[0].style.transform = `rotate(${this.getRandomIntInclusive(0, 180)}deg)`;
        });
    }

    static bind() {
        return Array.from(document.querySelectorAll(Paragraphs.join(','))).map((element) => {
            return new LeafGenerator(element);
        });
    }

    

    getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }
    getRandomIntInclusive(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min +1)) + min;
      }
    getRandomFloat(min, max) {
        return Math.round(((Math.random() * (max - min) + min) + Number.EPSILON) * 100) / 100;
    }

    getRandomFromRanges(ranges) {
        ranges.forEach(function(e) {
            console.log(Math.floor((Math.random() * (e.max - e.min + 1)) + e.min));
        })
    }
}

export { LeafGenerator };